import React, { useState } from 'react';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { IconButton, Menu, MenuItem } from '@mui/material';
import { ModalReject } from '../modals/modalReject/ModalReject';
import { useStyles } from './kebabMenu.styles';

const options = [
  'REJECT VOLUNTEER',
];

const ITEM_HEIGHT = 48;
export const KebabMenu = ({ volunteerId }: { volunteerId: string }): JSX.Element => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [visibleReject, setVisibleReject] = useState(false);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setVisibleReject(true);
  };

  return (
    <>
      <button className={classes.mainButton}>
        <IconButton
          aria-label="more"
          id="long-button"
          aria-controls={open ? 'long-menu' : undefined}
          aria-expanded={open ? 'true' : undefined}
          aria-haspopup="true"
          onClick={handleClick}
        >
          <MoreVertIcon />
        </IconButton>
        <Menu
          id="long-menu"
          MenuListProps={{
            'aria-labelledby': 'long-button',
          }}
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          PaperProps={{
            style: {
              maxHeight: ITEM_HEIGHT * 2,
              marginLeft: '-200px',
              marginTop: '-45px',
              border: '1px solid black',
              borderRadius: '8px',
              letterSpacing: '0.4px',
              textTransform: 'uppercase',
              alignItems: 'center',
              fontWeight: 500,
              fontSize: '14px',
              lineHeight: '24px',
              opacity: 1,
            },
          }}
        >
          {options.map((option) => (
            <button className={classes.mainButton}>
              <MenuItem key={option} onClick={handleClose}>
                {option}
              </MenuItem>
            </button>
          ))}
        </Menu>
      </button>
      <ModalReject
        open={visibleReject}
        setOpen={setVisibleReject}
        volunteerId={volunteerId}
      />
    </>
  );
};
